/* 🤖 this file was generated by svg-to-ts */
export const iconSearch: {
  name: 'search';
  data: string;
} = {
  name: 'search',
  data: `<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M2 6.5C2 4.019 4.019 2 6.5 2S11 4.019 11 6.5 8.981 11 6.5 11A4.505 4.505 0 0 1 2 6.5m-2 0C0 10.084 2.916 13 6.5 13a6.461 6.461 0 0 0 3.828-1.258l3.965 3.965a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-3.965-3.965A6.459 6.459 0 0 0 13 6.5C13 2.916 10.084 0 6.5 0A6.508 6.508 0 0 0 0 6.5"/></svg>`,
};
